// Copyright (c) 2020-2023 Visual Intelligence LP. All rights reserved.
//
export enum DayStatus {
  today = 'today',
  tomorrow = 'tomorrow',
  past = 'past',
  default = 'default',
}

export const TOKENS_KEYS = {
  access: 'vi_accessToken',
  refresh: 'vi_refreshToken',
  msLogin: 'vi_msLogin',
  googleLogin: 'vi_googleLogin',
  itwinsLogin: 'vi_itwinLogin',
  itwinsAuthCode: 'vi_itwinAuthCode'
};

// Translate a field name to a corresponding label.
export const Field2Label = {
  information: 'Site info',
  details: 'Site details',
  download: 'Documents',
  team: 'Team',
  folders: 'Catalog',
  shipping: 'Shipping',
  JobRequests: 'Job requests',
  Collect: 'Collect',
  //flightCollections: 'Flight collections',
  visuals: 'Ground',
  lidar: 'LiDAR',
  groundCollections: 'Ground collections',
  processing: 'Process',
  production: 'Production',
  externals: 'Externals',
  deliveries: 'Deliveries',
  performance: 'Summary',
  status: 'Workflow',
  dailyTracking: 'Tracking',
  visit: 'Site visit',
  latticeMeasurementGeneralInfo: 'General Info',
  latticeMeasurementGeometry: 'Geometry',
  latticeMeasurementPanels: 'Panels',
  latticeMeasurementMembers: 'Members',
  windAreaSummary: 'Summary',
  windAreaEquipments: 'Equipment',
  windAreaCalculation: 'Calculation',

  staffMain: 'Main Info',
  staffExtra: 'Extra Info',
  schedule: 'Schedule',
};

// Translate a field name to a corresponding label.
export const Field2LabelAlarms = {
  team: 'Team',
  taskCompletion: 'On task completion',
};


export const CatalogHeadingLabels = {
  collectionFolder: 'Collection folder',
  collectionServer: 'Collection server',
  LiDARFolder: 'LiDAR folder',
  LiDARServer: 'LiDAR server'
};